import React from 'react';
import { Trophy } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import Navigation from './Navigation';
import Footer from './Footer';
import { teamResults8u, teamResults9u, teamResults11u, teamResults13u, seasonHighlights } from '../mock';

const ResultsPage = () => {
  const allResults = [
    { title: '8U Team', data: teamResults8u },
    { title: '9U Team', data: teamResults9u },
    { title: '11U Team', data: teamResults11u },
    { title: '13U Team', data: teamResults13u },
  ];

  const getRecord = (games) => {
    if (!Array.isArray(games)) return null;
    const wins = games.filter(g => g.result === 'W').length;
    const losses = games.filter(g => g.result === 'L').length;
    const ties = games.filter(g => g.result === 'T').length;
    return `${wins}-${losses}${ties > 0 ? `-${ties}` : ''}`;
  };

  return (
    <div className="page-container">
      <Navigation />
      
      <main className="main-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="page-title">Season Results</h1>
            <p className="page-subtitle">2025 Season Highlights and Team Records</p>
          </div>
        </section>

        {/* Season Highlights */}
        {seasonHighlights && seasonHighlights.length > 0 && (
          <section className="highlights-section">
            <div className="container">
              <h2 className="section-title">Season Highlights</h2>
              <div className="highlights-container" data-testid="season-highlights-container">
                {seasonHighlights.map((highlight) => (
                  <Card key={highlight.id} className="highlight-card" data-testid={`highlight-card-${highlight.ageGroup}`}>
                    <CardContent>
                      <div className="highlight-header">
                        <div className="highlight-age-badge">{highlight.ageGroup}</div>
                        <Trophy className="highlight-trophy" size={48} />
                      </div>
                      <h3 className="highlight-achievement">{highlight.achievement}</h3>
                      <div className="highlight-record">{highlight.record}</div>
                      <div className="highlight-season">{highlight.season}</div>
                      {(highlight.pointsScored !== undefined || highlight.pointsAllowed !== undefined) && (
                        <div className="highlight-stats">
                          <div className="stat-item">
                            <div className="stat-value">{highlight.pointsScored}</div>
                            <div className="stat-label">Points Scored</div>
                          </div>
                          <div className="stat-item">
                            <div className="stat-value">{highlight.pointsAllowed}</div>
                            <div className="stat-label">Points Allowed</div>
                          </div>
                        </div>
                      )}
                      {Array.isArray(highlight.highlights) && highlight.highlights.length > 0 && (
                        <ul className="highlight-list">
                          {highlight.highlights.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      )}
                    </CardContent>
                  </Card>
                ))}
              </div>
            </div>
          </section>
        )}

        {/* Team Results */}
        <section className="results-section">
          <div className="container">
            <h2 className="section-title">Team Records</h2>
            <div className="results-grid">
              {allResults.map((team) => (
                <Card key={team.title} className="results-card">
                  <CardHeader>
                    <CardTitle>{team.title}</CardTitle>
                    {Array.isArray(team.data) && team.data.length > 0 && (
                      <div className="team-record">Record: {getRecord(team.data)}</div>
                    )}
                  </CardHeader>
                  <CardContent>
                    {Array.isArray(team.data) && team.data.length > 0 ? (
                      <div className="games-list">
                        {team.data.map((game) => {
                          const statusFor = (result) => {
                            if (result === 'W') return { status: 'win', label: 'Win' };
                            if (result === 'L') return { status: 'loss', label: 'Loss' };
                            return { status: 'tie', label: 'Tie' };
                          };
                          const { status, label } = statusFor(game.result);
                          return (
                            <div key={game.id} className={`game-result ${status}`}>
                              <span className="opponent">{game.opponent}</span>
                              <span className="score">{game.score}</span>
                              <span className={`result-badge ${status}`}>{label}</span>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p className="no-results">No games recorded yet</p>
                    )}
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default ResultsPage;
